
$(function () {

  var toggleAimAssist = function() {
    $('#easy-setup').toggleClass('aim-assist-on')
  }


  // Aim Assist Demo
  function aimAssistDemo() {
    $('#aim-assist-button').click(function() {
      toggleAimAssist()
    })
  }
  aimAssistDemo()

  setInterval(toggleAimAssist, 3000)


  // Cycle defaults
  $('.cycle').cycle()


  // Range finder image switcher
  $('.range').click(function() {
    var selectedDistance = $(this).attr('data-distance')

    $(this).addClass('active').siblings().removeClass('active')

    $(this).closest('#range-finder-tests').find('.screen').each(function() {
      var screenDistance = $(this).attr('data-distance')

      if (screenDistance === selectedDistance) {
        $(this).addClass('active')
      }
      else {
        $(this).removeClass('active')
      }
    })
  })


  // Position "Build Your System" button depending on page scroll position
  var positionButton = function () {

    // Reveal button as Gait section comes into view.
    $('#gait .container').waypoint(function(direction) {
      if (direction === 'down') {
        $('#build-your-own').addClass('is-fixed')
      }
      else if (direction === 'up') {
        $('#build-your-own').removeClass('is-fixed')
      }
    }, {
      offset: '100%'
    })

    // Make button 'inline' as last main section passes bottom of viewport
    $('main').waypoint(function(direction) {
      if (direction === 'down') {
        $('#build-your-own').removeClass('is-fixed').addClass('is-inline')
      }
      else if (direction === 'up') {
        $('#build-your-own').removeClass('is-inline').addClass('is-fixed')
      }
    }, {
      offset: 'bottom-in-view'
    })
  }
  positionButton()

})

/* lightbox */
$(document).ready(function() {

  $('.lightbox-gallery-one').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass:'mfp-fade', gallery:{enabled:true}});


  $('.lightbox-gallery-two').magnificPopup({type: 'image', delegate: 'a', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass:'mfp-fade', gallery:{enabled:true}});

  $('.lightbox-video').magnificPopup({type:'iframe', zoom: {enabled: true, duration: 300, easing: 'ease-in-out'}, removalDelay: 300, mainClass: 'mfp-fade'});

});
